module.exports = "<p>\n  PONER AQUÍ TEXTO DE CONDICIONES\n</p>\n"